export const TOKEN_KEY = "Token";
export const SENTRY_PUBLIC_DSN = import.meta.env.VITE_APP_SENTRY_PUBLIC_DSN;
const AWS_SFTP_LOCAL_SERVER_ID = "s-d9069519d8254edbb";

export enum EnvName {
  LOCAL = "LOCAL",
  STAGING = "STAGING",
  PRODUCTION = "PRODUCTION",
}

export const getEnvName = () => {
  const domainParts = window.location.hostname.split(".");
  const domainSuffix = domainParts[domainParts.length - 1];
  if (domainSuffix === "com") return EnvName.PRODUCTION;
  if (domainSuffix === "dev") return EnvName.STAGING;
  return EnvName.LOCAL;
};

const ENV = getEnvName();

// Backend URLs
const BASE_URL_MAP = {
  [EnvName.LOCAL]: `127.0.0.1:5000`,
  [EnvName.STAGING]: "classic.thehotspring.dev",
  [EnvName.PRODUCTION]: "classic.thehotspring.com",
};
const BASE_URL = BASE_URL_MAP[ENV];
export const getAPIBaseURL = (noAPIPrefix: boolean = false) => {
  if (noAPIPrefix) {
    if (ENV === EnvName.LOCAL) return `http://${BASE_URL}`;
    return `https://${BASE_URL}`;
  } else {
    if (ENV === EnvName.LOCAL) return `http://${BASE_URL}/api`;
    return `https://${BASE_URL}/api`;
  }
};
export const getProjectInvoiceDownloadURL = (invoiceId: string) =>
  `${getAPIBaseURL()}/invoice/${invoiceId}/export`;

export const getInstallSlackAppAuthorizationUrl = () => {
  console.log(`${getAPIBaseURL(true)}/slack-app/authorize`);
  return `${getAPIBaseURL(true)}/slack-app/authorize`;
};
export const getDeliveryNoteCsvUrl = (
  vendor_delivery_id: string,
  delivery_name: string,
) => {
  return `${getAPIBaseURL()}/delivery_note/${vendor_delivery_id}/${delivery_name}/export`;
};
export const getWebsocketAuthURL = () => {
  if (ENV === EnvName.LOCAL) return `ws://${BASE_URL}/ws/auth/graphql/`;
  return `wss://${BASE_URL}/ws/auth/graphql/`;
};
export const getGraphQLAuthURL = () => {
  if (ENV === EnvName.LOCAL) return `http://${BASE_URL}/auth/graphql/`;
  else return `https://${BASE_URL}/auth/graphql/`;
};
export const getGraphQLURL = () => {
  if (ENV === EnvName.LOCAL) return `http://${BASE_URL}/graphql/`;
  return `https://${BASE_URL}/graphql/`;
};

export const FTP_HOSTNAME_MAP = {
  [EnvName.LOCAL]: `${AWS_SFTP_LOCAL_SERVER_ID}.server.transfer.us-west-2.amazonaws.com`,
  [EnvName.STAGING]: "sftp.thehotspring.dev",
  [EnvName.PRODUCTION]: "sftp.thehotspring.com",
};
export const FTP_HOSTNAME = FTP_HOSTNAME_MAP[ENV];
export const FTP_PORT = "22";

export const SLAPSHOT_BASE_URL_MAP = {
  [EnvName.LOCAL]: "https://app.slapshot.work",
  [EnvName.STAGING]: "https://app.slapshot.work",
  [EnvName.PRODUCTION]: "https://app.slapshot.ai",
};

export const SlAPSHOT_BASE_URL = SLAPSHOT_BASE_URL_MAP[ENV];

export const getReviewToolURL = () => {
  if (ENV === EnvName.PRODUCTION) return `https://review.thehotspring.com`;
  if (ENV === EnvName.STAGING) return `https://review.thehotspring.dev`;
  return `http://review.127.0.0.1:5000`;
};

export const SHOT_FOOTAGE_IDENTIFIER = "FPO";

export const LOCAL_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const HOTSPRING_LINK = "https://www.thehotspring.com";
export const HELP_URL = "https://thehotspring.com/support/";

export const SUBCONTRACTING_FOR_USER = "_subcontracting_for_user";

export interface Currency {
  code: string;
  label: string;
}
// this value should match the CURRENCY_CHOICES in `settings.py`
export const CURRENCIES = [
  ["INR", "Indian rupee"],
  ["USD", "United States dollar"],
  ["AUD", "Australian dollar"],
  ["NZD", "New Zealand dollar"],
  ["GBP", "Great Britain Pound"],
  ["EUR", "Euro"],
  ["CAD", "Canadian dollar"],
].map((pair: string[]) => {
  const [code, label] = pair;
  const obj: Currency = {
    code,
    label,
  };
  return obj;
}) as Currency[];

export const CURRENCY_CODES = CURRENCIES.map(
  (currency: Currency) => currency.code,
) as string[];
export const DEFAULT_CURRENCY = "USD";
export const DEFAULT_SUBCONTRACTING_CURRENCY = "INR";
